<ng-container *ngIf="form && formCName && !disabled">
  <div [formGroup]="form">
    <p-editor [formControlName]="formCName" (keydown.enter)="onEditorEnterPressed($event)" [readonly]="disabled"
      [style]="{'height':'auto', 'min-height': '180px', 'max-height': '350px', 'overflow': 'auto'}"
      [modules]="{specialCharacters: true, sourceCodeButton: true}" (input)="onEditorChange($event)" (onTextChange)="onTextChange($event)">
      <p-header>
        <span class="ql-formats">
          <button class="ql-bold" title="Bold"></button>
          <button class="ql-italic" title="Italic"></button>
          <button class="ql-underline" title="Underline"></button>
          <button class="ql-strike" title="Strikethrough"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-color" title="Font Color"></select>
          <select class="ql-background" title="Font Background Color"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-script" value="sub" title="Subscript"></button>
          <button class="ql-script" value="super" title="Superscript"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered" title="Ordered List"></button>
          <button class="ql-list" value="bullet" title="Bullet List"></button>
          <button class="ql-indent" value="-1" title="Decrease Indent"></button>
          <button class="ql-indent" value="+1" title="Increase Indent"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-align" title="Text Alignment"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-link" title="Link"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean" title="Remove Format"></button>
        </span>
      </p-header>
    </p-editor>
  </div>
</ng-container>
<ng-container *ngIf="disabled">
  <div [formGroup]="form">
    <div class="toolbar">
      <button class="ql-viewsource" aria-label="Toggle Source" matTooltip="Toggle Source" (click)="sourceMode=!sourceMode"
        class="ql-source-editing-button" type="button" tabindex="-1">
        <svg class="" viewBox="0 0 20 20">
          <path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"></path>
          <path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"></path>
        </svg>
      </button>
    </div>
    <textarea class="simple-editor"
              *ngIf="sourceMode"
              readonly
              [formControlName]="formCName"
    ></textarea>
    <div class="simple-editor"
         *ngIf="!sourceMode"
         [innerHTML]="form.get(formCName).value || '' | safeHtml"
    ></div>
  </div>
</ng-container>

